import { render, staticRenderFns } from "./release_block_assets.vue?vue&type=template&id=5837e2ba&"
import script from "./release_block_assets.vue?vue&type=script&lang=js&"
export * from "./release_block_assets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports